import { Modal, ROLE } from 'baseui/modal'
import { Button, KIND, SIZE } from 'baseui/button'
import useAbandonContract from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Tools/AbandonContract/useAbandonContract'
import AbandonModalContent from '@/shared/components/contracts/AbandonModalContent'
import IconCarbonTrashCan from '@/shared/icons/IconCarbonTrashCan'

const AbandonContract = () => {
  const {
    t,
    isOpen,
    setIsOpen,
    canShowAbandonButton,
    isAlreadyRetracted,
    handleSubmit,
  } = useAbandonContract()

  if (!canShowAbandonButton || isAlreadyRetracted) {
    return null
  }

  return (
    <>
      <Button
        kind={KIND.secondary}
        size={SIZE.compact}
        onClick={() => setIsOpen(true)}
        startEnhancer={() => <IconCarbonTrashCan size={24} />}
      >
        {t('subscriptionTable:abandon')}
      </Button>
      <Modal onClose={() => setIsOpen(false)} isOpen={isOpen} animate autoFocus size={SIZE.full} role={ROLE.dialog}>
        <AbandonModalContent onSubmit={handleSubmit} minLength={10} />
      </Modal>
    </>
  )
}

export default AbandonContract
